<script lang="ts" setup>
import { useSearchStore } from "@/stores/search";
import { computed, onBeforeMount } from "vue";
import { storeToRefs } from "pinia";

const store = useSearchStore();
const { initTeaser } = store;

onBeforeMount(async () => {
    await initTeaser();
});

const teaser = computed(() => {
    return store.getTeaser;
});
const showTeaser = computed(() => {
    return store.hasTeaser;
});
const { isPalm } = storeToRefs(store);
</script>
<template>
    <div class="[ c-teaser ]" v-if="showTeaser">
        <div
            class="[ c-teaser__bg-picture ]"
            :aria-label="isPalm ? teaser?.imageMobile.alt : teaser?.image.alt"
            :style="{
                '--teaser-bg-img-url': 'url(' + teaser?.image.path + ')',
                '--teaser-bg-img-position': teaser?.image.backgroundPosition,
                '--teaser-bg-img-url-mobile':
                    'url(' + teaser?.imageMobile.path + ')',
                '--teaser-bg-img-position-mobile':
                    teaser?.imageMobile.backgroundPosition,
            }"
        ></div>
        <div class="[ c-teaser__text ]">
            <div class="[ c-teaser__text-content ]">
                <h1 class="[ c-teaser__text-headline ]">
                    {{ isPalm ? teaser?.headerMobile : teaser?.header }}
                </h1>
                <p
                    class="[ c-teaser__text-sub-headline ]"
                    v-html="isPalm ? teaser?.textMobile : teaser?.text"
                ></p>
            </div>
        </div>
    </div>
</template>
